<template>
  <div id="public" :class="{ publicBG: isBrowserGame }">
    <Waiting v-if="loading" />
    <div class="arrow" v-if="arrow_r">
      <img class="arrow" src="../assets/inventory/arrow.gif" />
    </div>
    <CanvasComponent
      ref="canvas"
      :inventoryClicked="inventoryClicked"
      v-if="isBrowserGame"
    ></CanvasComponent>
    <DustParticles v-if="isBrowserGame && !loading && !video && isChromium"></DustParticles>
    <!--  <div class="name" v-if="anydialogue != null || talkingTo != null">
      {{ talkingTo }}
    </div>-->
    <img
      v-if="showImage"
      :src="imageUrl"
      :style="imageStyle"
      class="cursor-image"
    />
    <!-- //TODO: interaktion als :seekd="" an layer 0 anhängen -->
    <div id="fakeaction" v-if="fakeActionMode">
      <div v-for="(layer, key) in fakeActionVideos" class="v0" v-bind:key="key">
        <video
          class="v1"
          :ref="'fa' + layer.layer"
          :key="currentFakeActionVideos[layer.layer]"
          :style="{ 'z-index': layer.layer }"
          :loop="layer.loop"
          autoplay
          @seeked="loopEnded(layer)"
          @ended="actionEnded(layer.onend)"
          :src="currentFakeActionVideos[layer.layer]"
          type="video/mp4;codecs=hvc1.2.4.L153.B0"
        ></video>
      </div>
    </div>
    <div id="video" v-if="video">
      <video class="video" muted :src="getVideo(true)"></video>
      <video
        class="video"
        loop
        autoplay
        muted
        :src="getVideo(true)"
        v-if="!isBusy"
      ></video>
      <video
        class="video"
        autoplay
        muted
        :src="getVideo()"
        v-if="isBusy"
      ></video>
    </div>
    <div id="event" v-if="event">
      <video
        class="video top"
        autoplay
        :src="getEvent()"
        @ended="eventEnded"
      ></video>
    </div>
    <div id="menu">
      <div id="controls">
        <div class="block" v-if="!anydialogue">
          <h1
            @click="command($event, 'n')"
            class="commands"
            :class="{ clickable: isBrowserGame }"
          >
            Nimm
          </h1>
          <h1
            @click="command($event, 'r')"
            class="commands"
            :class="{ clickable: isBrowserGame }"
          >
            Rede
          </h1>
          <h1
            @click="command($event, 's')"
            class="commands"
            :class="{ clickable: isBrowserGame }"
          >
            Schau
          </h1>
        </div>
        <div class="block" v-if="!anydialogue">
          <h1
            @click="command($event, 'b')"
            class="commands"
            :class="{ clickable: isBrowserGame }"
          >
            Benutze
          </h1>
          <h1
            @click="command($event, 'd')"
            class="commands"
            :class="{ clickable: isBrowserGame }"
          >
            Drücke
          </h1>
          <h1
            @click="command($event, 'z')"
            class="commands"
            :class="{ clickable: isBrowserGame }"
          >
            Ziehe
          </h1>
        </div>
        <div id="inventory" v-if="!anydialogue">
          <div class="slot" v-for="index in 12" :key="index">
            <img
              class="item"
              v-if="inventory[index - 1] != undefined"
              :src="getUrl(index - 1)"
              @click="interact(inventory[index - 1])"
            />
          </div>
        </div>
        <div id="dialogue" v-else>
          <ul v-if="anydialogue.options.filter(isShown)">
            <li
              v-for="(option, idx) in anydialogue.options.filter(isShown)"
              :key="idx"
            >
              <div
                @click="ChooseOption(option, idx)"
                class="dialoguebox"
                v-bind:class="{
                  selected: selected == idx,
                  hide: selected != idx && selected != null,
                  clickable: isBrowserGame,
                }"
              >
                > {{ getText(option.text) }}
              </div>
            </li>
          </ul>

          <img v-if="polaroid" id="polaroid" :src="polaroid" />
        </div>
      </div>
    </div>

    <MoBot />
  </div>
</template>

<script>
import Waiting from "./waiting.vue";
import CanvasComponent from "./canvas.vue";
import DustParticles from "./effects.vue";
import MoBot from "./mobot.vue";
import { isShown } from "../mixins/isShown.js";
import { getText } from "../mixins/getText.js";
import { mapGetters } from "vuex";
export default {
  name: "Public",
  mixins: [isShown, getText],
  components: { Waiting, CanvasComponent, DustParticles, MoBot },
  props: {},
  data() {
    return {
      currentFakeActionVideos: [],
      inventoryClicked: null,
      showImage: false,
      imageUrl: require("../assets/inventory/flask.png"), // Pfad zu deinem Bild
      imageStyle: {
        position: "absolute",
        left: "0px",
        top: "0px",
        opacity: 0,
        pointerEvents: "none", // Wichtig, damit das Bild keine Maus-Events abfängt
      },
      isChromium: false,
    };
  },
  computed: {
    ...mapGetters([
      "dialogues",
      "conditions",
      "items",
      "currentDialogue",
      "anydialogue",
      "talkingTo",
      "selected",
      "inventory",
      "loading",
      "video",
      "fakeActionMode",
      "nextFakeAction",
      "fakeActionVideos",
      "event",
      "idle",
      "isBusy",
      "arrow_r",
      "isBrowserGame",
      "playerNext",
      "userCommand",
      "userCombineWith",
    ]),
    polaroid() {
      if ("img" in this.currentDialogue) {
        return require("../assets/polaroid/" + this.currentDialogue.img);
      }
      return false;
    },
    
  },
  created() {
    this.$root.$refs.public = this;
    this.checkBrowser();
  },
  watch: {
    fakeActionVideos() {
      this.currentFakeActionVideos = [];
      for (let layer in this.fakeActionVideos) {
        this.currentFakeActionVideos.push(
          this.getFakeAction(this.fakeActionVideos[layer].video)
        );
        if (this.$refs["fa" + layer]) {
          this.$refs["fa" + layer][0].load();
        }
      }
    },
    userCombineWith(val) {
      if (!val) {
        this.imageStyle.opacity = 0;
        this.showImage = false;
      }
    },
  },
  methods: {
    getUrl(id) {
      let file;
      if (this.inventory[id].img.constructor === Array) {
        if ("v" in this.inventory[id]) {
          file = this.inventory[id].img[this.inventory[id].v];
        } else {
          file = this.inventory[id].img[0];
        }
      } else {
        file = this.inventory[id].img;
      }
      return require("../assets/inventory/" + file);
    },
    getVideo(idle = false) {
      return idle
        ? require("../assets/audio/" + this.idle)
        : require("../assets/audio/" + this.video);
    },
    getFakeAction(video) {
      if (typeof video === "object") {
        if ("default" in video) {
          for (let condition in video) {
            if (condition != "default") {
              if (condition in this.conditions) {
                if (this.conditions[condition].check == true) {
                  return require("../assets/videos/" + video[condition]);
                }
              } //check if condition is item
              if (condition in this.items) {
                if (this.items[condition].inMantu == true) {
                  return require("../assets/videos/" + video[condition]);
                }
              }
            }
          }
          return require("../assets/videos/" + video.default);
        }
      }
      if (Array.isArray(video)) {
        const index = Math.floor(Math.random() * video.length);
        console.log("random: " + index);
        console.log(video[index]);
        return require("../assets/videos/" + video[index]);
      }
      return require("../assets/videos/" + video);
    },
    getEvent() {
      return require("../assets/videos/" + this.event);
    },
    eventEnded() {
      this.$store.commit("stopVideo");
      this.$store.commit("toggleMute");
    },
    getPolaroid(id) {
      let file;
      if (this.inventory[id].img.constructor === Array) {
        if ("v" in this.inventory[id]) {
          file = this.inventory[id].img[this.inventory[id].v];
        } else {
          file = this.inventory[id].img[0];
        }
      } else {
        file = this.inventory[id].img;
      }
      return require("../assets/inventory/" + file);
    },
    actionEnded(onend) {
      console.log("action ended", onend);
      //this.$root.$refs.private.interaction = onend
      //  let interaction = this.$root.$refs.speaker.checkConditions(onend);
      this.$root.$refs.private.startAction(onend, true);
      this.$root.$refs.private.nextActions(onend);
      //  this.$root.$refs.speaker.checkActions(interaction, true);
      //  this.$root.$refs.speaker.continue();
    },
    loopEnded(layer) {
      if (layer.layer == 0 && this.nextFakeAction) {
        this.$store.commit("startFakeAction", this.nextFakeAction);
        this.$store.commit("unsetNextFakeAction");
      } else {
        this.$set(
          this.currentFakeActionVideos,
          layer.layer,
          this.getFakeAction(this.fakeActionVideos[layer.layer].video)
        );
        //this.currentFakeActionVideos[layer.layer] = this.getFakeAction(this.fakeActionVideos[layer.layer].video)
        //console.log(this.$refs)
        //this.$refs[layer.layer][0].load();
        //this.$refs['fa'+layer.layer][0].load();
        /*
        this.getFakeAction(layer.video);
        console.log("current:")*/
        console.log(this.currentFakeActionVideos);
      }
    },
    command(event, command) {
      if (this.isBrowserGame) {
        //andere commands deaktivieren
        const elemente = document.querySelectorAll(".commands.active");
        elemente.forEach((el) => {
          el.classList.remove("active");
        });
        event.target.classList.add("active");
        this.$store.commit("updateUserCommand", command);
      }
    },
    ChooseOption(options, id) {
      if (this.isBrowserGame) {
        this.$root.$refs.private.$refs._dialogue.ChooseOption(options, id);
      }
    },
    interact(item) {
      if (this.userCombineWith) {
        let itemID = this.$store.getters.itemByName(item.text);
        // TODO: gleiches Item verhindern?
        this.$refs.canvas.combineWithItem(itemID);
        this.$refs.canvas.startAction();
      } else {
        let command = "s";
        if (this.userCommand) {
          command = this.userCommand;
        }
        if (this.userCommand == "b") {
          let itemID = this.$store.getters.itemByName(item.text);
          this.$store.commit("userCombineWith", itemID);
          this.attachImageToCursor();
        } else {
          let actions = item.actions[command];
          this.action = actions;
          this.inventoryClicked = null;
          this.wait(1).then(() => {
            this.inventoryClicked = actions;
          });
        }
      }
    },
    attachImageToCursor() {
      this.showImage = true;
      document.addEventListener("mousemove", this.updateImagePosition);
    },
    updateImagePosition(event) {
      this.imageStyle.left = `${event.clientX}px`;
      this.imageStyle.top = `${event.clientY}px`;
      this.imageStyle.opacity = 1;
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    checkBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
    //  this.isChrome = /chrome|chromium/.test(userAgent) && !/edge|edg|opr/.test(userAgent);
      this.isChromium = /chrome|chromium/.test(userAgent);
    }
  },
  beforeDestroy() {
    // Entferne den Event-Listener, wenn die Komponente zerstört wird
    document.removeEventListener("mousemove", this.updateImagePosition);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../scss/_variables.scss";
ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin: margin-default;
  cursor: pointer;
}
#public {
  font-family: lores-15, sans-serif;
  font-weight: 700;
  font-style: normal;
  width: $width;
  height: $height;
  background: transparent;
  cursor: none;
}
.publicBG {
  width: $width;
  height: $height;
  background: black;
  cursor: pointer !important;
}
.active {
  color: #e5007e;
}
h1 {
  font-size: $button-text;
  font-family: lores-15, sans-serif;
  font-weight: 700;
  font-style: normal;
  font-style: normal;
  color: #d0d0d0;
  margin: $margin-small;
}
.public {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.clickable:hover {
  color: white;
}
#fakeaction {
}
.v0 {
  height: $height;
  position: absolute;
  width: 100%;
}
.v1 {
  height: $height;
  position: absolute;
  width: 100%;
}
.v2 {
  height: $height;
  position: absolute;
  width: 100%;
  z-index: 2;
}
.v3 {
  height: $height;
  position: absolute;
  width: 100%;
  z-index: 3;
}
.v4 {
  height: $height;
  position: absolute;
  width: 100%;
  z-index: 4;
}
.name {
  position: absolute;
  display: list-item;
  width: calc(900px * 2);
  color: #e5007e !important;
  //  background: #312700;
  background-image: url("../assets/background2.jpg");
  background-size: cover;
  padding: calc(5px * 2);
  padding: calc(10px * 2) calc(30px * 2);
  font-weight: bold;
  color: white;
  font-size: 16px;
}
#menu {
  //  background: #312700;
  background-image: url("../assets/background2.jpg");
  background-size: cover;
  height: $menu-height;
  width: $width;
  position: absolute;
  //  width: 100%;
  top: $height;
}
#controls {
  display: flex;
  flex-direction: row;
  padding: 0px $margin-big;
}
#inventory {
  //  height: 100%;

  height: $inventory-height;
  //  width: calc(100% - 10px);
  width: $inventory-width;
  margin: 0px 0 0px $margin-mid;
  border: solid $border #4a4f37;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background: rgba(49, 27, 27, 0.85);
  //background: rgb(49, 18, 31);
}
#polaroid {
  //  background: #e5007e;
  //  width: 200px;
  width: auto;

  height: $polaroid-height;
  position: absolute;
  right: $polaroid-right;
  bottom: $polaroid-bottom;
  transform: rotate(4deg);
}
.slot {
  height: $slot-height;
  //width: calc((100% / 7) - 2.5px);
  width: $slot-width;
  padding: $padding-slot;
  border: solid $border #4a4f37;
}
.item {
  width: 100%;
  height: 100%;
  /*    -webkit-filter: drop-shadow(3px 3px 0 #e5007e)
                  drop-shadow(-3px -3px 0 #e5007e);
  filter: drop-shadow(3px 3px 0 #e5007e) 
          drop-shadow(-3px -3px 0 #e5007e);*/
  filter: drop-shadow(1px 1px 0px rgba(0, 0, 0, 1))
    drop-shadow(-1px -1px 0px rgba(255, 255, 255, 1));
}
.block {
  padding: $margin-default $margin-small;
}
.options {
  width: 500px;
}
.hide {
  opacity: 0;
  transition: opacity 200ms ease-out;
}

.dialoguebox {
  display: inline-block;
  //  background: rgba(205, 134, 63, 0.5);
  padding: 0 $dialoguebox-padding 0 $dialoguebox-padding;
  font-weight: bold;
  //color: white;
  color: #d0d0d0;
  font-size: $dialogue;
  opacity: 100;
  transition: background 50ms ease-out;
}
.selected {
  //  background: rgba(255, 0, 255, 0.5);
  color: #e5007e;
  transition: background 200ms ease-out;
}
#video,
#event {
  width: $width;
  height: $height;
  position: absolute; //Maybe problem
  top: 0; //Maybe problem
}
.video {
  top: 0;
  position: absolute;
  width: $width;
  height: $height;
}
.top {
  z-index: 100;
}
$arrow: $margin-default * 4;
$arrowtop: $height / 2 - 2 * $margin-default;

div.arrow {
  top: $arrowtop;
  width: $arrow;
  height: $arrow;
  right: $margin-big;
  position: absolute;
}
img.arrow {
  width: $arrow;
  height: auto;
}
.cursor-image {
  z-index: 40;
}
</style>
